import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-report",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 14v4h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 11v-4a2 2 0 0 0 -2 -2h-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 11h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 15h3" })
	]
});
const ForwardRef = forwardRef(SvgReport);
export default ForwardRef;
